export default "/assets/images/tech_page_03_sm.379b97bda0bf4dd6.mp4";